import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/app";
import { configureServices } from "./shared/api/configure-services";

import "./index.css";

const rootEl = document.getElementById("root");

if (!rootEl) {
  throw new Error("Root element #root not found");
}

async function bootstrap() {
  // Проводим base URL + источник токена в @synthesis/shared-services до первого запроса.
  configureServices();

  createRoot(rootEl as HTMLElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
